export default "__VITE_ASSET__Bqkf5H5b__"